var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1FED9713-E177-4BBF-B7EA-B146AF6A870C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Summary-Cards",
    transform: "translate(-386.000000, -2023.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(360.000000, 1993.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-job",
    transform: "translate(24.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,3.0042651 C7,2.4496248 7.44910619,2 7.99539757,2 L16.0046024,2 C16.5543453,2 17,2.45097518 17,3.0042651 L17,6 L21.0013542,6 C21.552891,6 22,6.44910619 22,6.99539757 L22,15.0046024 C22,15.5533768 21.553049,15.9984293 21,15.9999959 L21,21.0029699 C21,21.5536144 20.5550537,22 20.0001464,22 L3.99985364,22 C3.44764972,22 3,21.5527431 3,21.0029699 L3,16 C2.44762442,16 2,15.5508938 2,15.0046024 L2,6.99539757 C2,6.44565467 2.44576991,6 2.99864581,6 L7,6 L7,3.0042651 Z M9,6 L15,6 L15,4 L9,4 L9,6 Z M5,20 L19,20 L19,16 L15,16 L15,16.9957349 C15,17.5503752 14.5490248,18 13.9957349,18 L10.0042651,18 C9.4496248,18 9,17.5490248 9,16.9957349 L9,16 L5,16 L5,20 Z M15,14 L20,14 L20,8 L4,8 L4,14 L9,14 L9,13.0042651 C9,12.4496248 9.45097518,12 10.0042651,12 L13.9957349,12 C14.5503752,12 15,12.4509752 15,13.0042651 L15,14 Z M11,14 L11,16 L13,16 L13,14 L11,14 Z",
    id: "path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.3b04c7f1a30df22cb21a072462d59810.svg";
export { ForwardRef as ReactComponent };